import { layout } from '../../App.routing'
import { EditionPublication } from '@west-australian-newspapers/message-types'

export const latestEditionSegment = layout.component({
    type: 'nightly-latest-edition',
    props: {
        dataDefinitionArgs: {
            type: 'edition',
            page: 1,
            pageSize: 1,
            publication: 'the_nightly',
        },
        title: 'Latest Edition',
        type: 'homepage',
        lazyloadImages: true,
    },
})

export const previousEditionsSegment = layout.component({
    type: 'nightly-previous-editions',
    props: {
        dataDefinitionArgs: {
            type: 'edition',
            page: 1,
            pageSize: 5,
            publication: 'the_nightly',
        },
        title: 'All Editions',
        type: 'homepage',
        lazyloadImages: true,
    },
})

export const specialEditionSegment = (
    publicationTitle: string,
    publication: EditionPublication,
    showFirstDivider?: boolean,
    heading?: string,
) =>
    layout.component({
        type: 'nightly-special-edition-home',
        props: {
            dataDefinitionArgs: {
                type: 'edition',
                page: 1,
                pageSize: 1,
                publication,
            },
            lazyloadImages: true,
            publicationTitle,
            publication,
            showFirstDivider,
            heading,
        },
    })
